var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order.date_delivered == null && _vm.statusShip == 3)?_c('div',[_c('v-btn',{attrs:{"block":"","dark":"","color":"red"},on:{"click":function($event){return _vm.HandlerMoveFinal(_vm.order)}}},[_vm._v("Finalizado")]),(
      _vm.order.user_btn_prepeared != null ||
      _vm.order.user_btn_delivered != null ||
      _vm.order.user_btn_in_transit != null
    )?_c('move-toltip-component',{attrs:{"order":_vm.order}}):_vm._e()],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }